import { Route, Routes } from "react-router-dom"

import AccountBillingInvoice from "./Invoice"
import AccountBillingOverview from "./Overview"

export default function AccountBilling({ customer, user }: any) {
  return (
    <Routes>
      <Route path="" element={<AccountBillingOverview customer={customer} user={user} />} />
      <Route path="invoices/:invoice_id" element={<AccountBillingInvoice customer={customer} user={user} />} />
    </Routes>
  )
}